import { render, staticRenderFns } from "./DeliveryHeatMap.vue?vue&type=template&id=472567a0&lang=pug&"
import script from "./DeliveryHeatMap.vue?vue&type=script&lang=ts&"
export * from "./DeliveryHeatMap.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryHeatMap.vue?vue&type=style&index=0&id=472567a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports